import { IconPlay, IconPause } from 'components/ui/icons/player';
import { FC, useState } from 'react';
import styles from './ether.module.scss';

interface IProps {
  icon: string;
  title: string;
  time: string;
  section: string;
}

export const Ether: FC<IProps> = ({ icon, title, time, section }) => {
  const [isPlay, setIsPlay] = useState(false);

  const onPlay = () => {
    setIsPlay(!isPlay);
  };

  return (
    <article className={styles.ether}>
      <section className={styles.image}>
        <img src={icon} alt={title} height={100} width={100} />
        <button onClick={onPlay} className={styles.btn}>
          {!isPlay ? <IconPlay viewBox={'-2 1 36 36'} /> : <IconPause />}
        </button>
      </section>
      <p className={styles.time}>{time}</p>
      <p className={styles.title}>{title}</p>
      <p className={styles.section}>{section}</p>
    </article>
  );
};
